import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {LuLayoutDashboard} from "react-icons/lu";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import API from "../../Services/API";
import Loading from "../../Layouts/Loading";
import { saveAs } from 'file-saver';
import {TbReportSearch} from "react-icons/tb";

const currencyFormat = Intl.NumberFormat('en-US');

function VendorSaleMonthReport() {

    const [report, setReport] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(true);

    const  MNo = [0,1,2,3,4,5,6,7,8,9,10,11];
    const Mname   = [
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ]

    const onGetReport = (excel = 0) => {


        let params = {
            count: 100,
            page: 1,
            list: 0,
            orderBy: 'created_at',
            orderType: 'desc',
            excel,
        }

        setIsLoaded(false)

            API.getVendorMonthReport(params)
                .then((response) => {
                    setIsLoaded(true)
                    if (!excel) {
                        setReport(response.data);
                    } else {
                        const outputFilename = `ngkhVendorMonth${Date.now()}.xlsx`;

                        const blob = new Blob([response], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });

                        saveAs(blob, outputFilename);
                    }

                })
                .catch((error) => {
                    setIsLoaded(true)
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });

    }


    return (
        <React.Fragment>
            <Header/>
            {
                !isLoaded && <Loading/>
            }
            <Navbar page="monthVendors"/>
            <Toast/>
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <LuLayoutDashboard className='ms-2'/>
                        گزارش فروش و برگشتی نمایندگان به تفکیک ماه
                    </h1>

                </div>

                <section className="section dashboard">
                    <div className="row rtl">
                        <div className="col--12">

                            <div className="card info-card customers-card">


                                <div className="card-body">

                                    <div className="row filter-box mb-5 pb-2 rounded text-small-2">
                                        <div className='col-12 mt-3 p-3'>
                                            <TbReportSearch className='text-big-5 text-primary mx-2'/>
                                            برای دریافت گزارش در صورت نیاز به دریافت فایل اکسل دکمه دریافت اکسل (دکمه
                                            آبی) را بزنید و در صورتی که می خواهید در همین صفحه نمایش داده شود دکمه
                                            دریافت گزارش (دکمه سبز) را بزنید و تا دریافت کامل گزارش صبر کنید.
                                        </div>
                                        <div className='col-md-6 mt-3'>
                                            &nbsp;
                                        </div>

                                        <div className='col-md-3 mt-3'>
                                            <button className='btn btn-success w-100 mt-4 text-small-1'
                                                    onClick={() => {
                                                        onGetReport(0)
                                                    }}
                                            >
                                                دریافت گزارش
                                            </button>
                                        </div>
                                        <div className='col-md-3 mt-3'>
                                            <button className='btn btn-primary w-100 mt-4 text-small-1'
                                                    onClick={() => {
                                                        onGetReport(1)
                                                    }}
                                            >
                                                دریافت اکسل
                                            </button>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>
                        {
                            report.length > 0 &&

                            <div className="col-12">
                                <div className="card info-card sales-card">
                                    <div className="card-body rtl">

                                        {
                                            MNo.map(m => {

                                                return (

                                                    <div>
                                                    <div className='mt-5 fw-bold text-success pe-4 mb-2 '>

                                                            {Mname[m]}

                                                            &nbsp;
                                                            ۱۴۰۳
                                                        </div>
                                                        <table className="table  text-center table-striped">
                                                            <thead>
                                                            <tr className='text-small-2 text-muted'>
                                                                <th scope="col"
                                                                    className='bg-success-subtle rounded-end-3'>
                                                                    نماینده
                                                                </th>
                                                                <th scope="col" className='bg-success-subtle'>تعداد فروش
                                                                </th>
                                                                <th scope="col" className='bg-success-subtle'>فروش آمپری
                                                                </th>
                                                                <th scope="col" className='bg-success-subtle'>تعداد
                                                                    برگشتی
                                                                </th>
                                                                <th scope="col"
                                                                    className='bg-success-subtle rounded-start-3'>برگشتی
                                                                    آمپری
                                                                </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>

                                                            {
                                                                report[m]?.map((vendor) => {
                                                                    return (
                                                                        <tr key={vendor.id}
                                                                            role='button'
                                                                        >

                                                                            <td>
                                                                                {vendor.title}
                                                                                {vendor.name}
                                                                            </td>
                                                                            <td>

                                                                                {currencyFormat.format(vendor.status_8_count)}
                                                                            </td>
                                                                            <td>
                                                                                {currencyFormat.format(vendor.status_8_amp)}

                                                                            </td>
                                                                            <td>
                                                                                {currencyFormat.format(vendor.status_10_count)}

                                                                            </td>
                                                                            <td>
                                                                                {currencyFormat.format(vendor.status_10_amp)}

                                                                            </td>


                                                                        </tr>
                                                                    )
                                                                })
                                                            }

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default VendorSaleMonthReport;